export default __webpack_public_path__ + "static/media/announcement-error.bb729cdb.svg";